/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Cmp_Per_MonthInputs */

const en_pc_cmp_per_month = /** @type {(inputs: Pc_Cmp_Per_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/month`)
};

const zh_pc_cmp_per_month = /** @type {(inputs: Pc_Cmp_Per_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/月`)
};

/**
* | output |
* | --- |
* | "/month" |
*
* @param {Pc_Cmp_Per_MonthInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_cmp_per_month = /** @type {((inputs?: Pc_Cmp_Per_MonthInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Cmp_Per_MonthInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_cmp_per_month(inputs)
	return zh_pc_cmp_per_month(inputs)
});
export { pc_cmp_per_month as "pc.cmp.per_month" }